/* eslint-disable no-return-assign */
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../actions';
import * as c from '../constant';

function PreviousOR({ data, getReportAccess }) {
  const setModal = useContext(ModalContext);
  const [src, setSrc] = useState('');
  const authProfile = getJson('profile') || {};

  useEffect(() => {
    const args = {
      path: c.BPLS_E2E_PREVIOUS_EOR_URL.replace('{id}', _.get(data, 'id')),
      email: _.get(authProfile, 'email'),
      output: 'I',
    };
    getReportAccess(args, (response) => {
      setSrc(response?.res?.res?.url || '');
    });
  }, []);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Preview Application"
                  src={src || ''}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

PreviousOR.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(PreviousOR);
